module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/e-photo_studio-3-c459d9457f697e5e9990e122dc6fb803.png";